import { styled } from "styletron-react";

const LogoSubText = styled("span", () => ({
  color: "#000000",
  fontWeight: "bold",
  fontSize: "14px",
  marginTop: "-10px",
}));

export { LogoSubText };
